import React from "react";
// import { MerchPartner } from "./merchPartnerContent";
import MerchPartner from "./merchPartner";
import MerchEvents from "./merchServices";
import EquipmentHire from "./equipmentHire";
import EHire from "./eHire";
import ContactForm from "./footer2";
import AboutUs from "./aboutUs";
import BannerHome from "./banner";
import Form from "./form.js";
import StatsBar from "./experience.js";
import ServicesSection from "./services-section.js";
import MerchandisePartners from "./merchPartnerContent.js";


function Home() {

    return <div className="home">
              {/* <div className="topbanner">
  <a href="https://store.nzc.nz/" target="_blank" rel="noopener noreferrer">
    <img className='banner' src="/img/home/banner2.jpg" alt="Logo" />
  </a>
</div> */}
                
                <BannerHome />
                <StatsBar />
                <AboutUs />
                {/* <MerchPartner /> */}
                <MerchandisePartners />
                {/* <ServicesSection /> */}
                <EquipmentHire />
                <MerchEvents />
                
                {/* <EHire /> */}

                
                
      <a href="./form.js" className="whitec">
        f
      </a>

</div>
        
}

export default Home;